(function () {
  var animatedMediaObserver = null;
  var animatedMediaIntentReady = false;
  var animatedMediaCanLoad = false;

  function loadAnimatedImage(image) {
    if (image.dataset.gdAnimatedReady === 'true') return;
    var animatedSrc = image.dataset.gdAnimatedSrc;
    if (!animatedSrc) return;
    image.dataset.gdAnimatedReady = 'true';
    image.src = animatedSrc;
    if (animatedMediaObserver) {
      animatedMediaObserver.unobserve(image);
    }
  }

  function loadVisibleAnimatedMedia() {
    document.querySelectorAll('img[data-gd-animated-src][data-gd-animated-visible="true"]').forEach(loadAnimatedImage);
  }

  function markAnimatedMediaIntent() {
    animatedMediaCanLoad = true;
    loadVisibleAnimatedMedia();
  }

  function initAnimatedMediaIntent() {
    if (animatedMediaIntentReady) return;
    animatedMediaIntentReady = true;
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (eventName) {
      window.addEventListener(eventName, markAnimatedMediaIntent, { once: true, passive: true });
    });
  }

  function initAnimatedMedia(root) {
    var scope = root || document;
    var images = scope.querySelectorAll('img[data-gd-animated-src]');
    if (!images.length) return;
    initAnimatedMediaIntent();

    if (!('IntersectionObserver' in window)) {
      if (animatedMediaCanLoad) images.forEach(loadAnimatedImage);
      return;
    }

    if (!animatedMediaObserver) {
      animatedMediaObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.dataset.gdAnimatedVisible = 'true';
          if (animatedMediaCanLoad) loadAnimatedImage(entry.target);
        });
      }, { rootMargin: '0px 0px' });
    }

    images.forEach(function (image) {
      if (image.dataset.gdAnimatedReady === 'true') return;
      animatedMediaObserver.observe(image);
    });
  }

  function initFaq(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gd-faq]').forEach(function (group, groupIndex) {
      group.querySelectorAll('[data-gd-faq-button]').forEach(function (button, itemIndex) {
        var panel = button.nextElementSibling;
        var buttonId = button.id || 'gd-faq-button-' + groupIndex + '-' + itemIndex;
        var panelId = panel && panel.id ? panel.id : 'gd-faq-panel-' + groupIndex + '-' + itemIndex;
        button.id = buttonId;
        button.setAttribute('aria-controls', panelId);
        if (panel) {
          panel.id = panelId;
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-labelledby', buttonId);
        }

      if (button.dataset.gdReady === 'true') return;
      button.dataset.gdReady = 'true';
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var group = button.closest('[data-gd-faq]');
        if (group) {
          group.querySelectorAll('[data-gd-faq-button]').forEach(function (otherButton) {
            otherButton.setAttribute('aria-expanded', 'false');
          });
        }
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
      });
    });
  }

  function initMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gd-mobile-menu], .gd-mobile-menu').forEach(function (menu) {
      if (menu.dataset.gdMenuReady === 'true') return;
      menu.dataset.gdMenuReady = 'true';
      var button = menu.querySelector('[data-gd-mobile-menu-button], .gd-mobile-menu__button, summary');
      var panel = menu.querySelector('[data-gd-mobile-menu-panel], nav');
      if (!button || !panel) return;

      function syncLabel() {
        var isOpen = menu.classList.contains('is-open') || menu.open;
        button.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      function setOpen(open) {
        menu.classList.toggle('is-open', open);
        panel.hidden = !open;
        if (open) {
          if ('open' in menu) menu.setAttribute('open', '');
        } else {
          if ('open' in menu) menu.removeAttribute('open');
        }
        syncLabel();
      }

      panel.hidden = true;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(!menu.classList.contains('is-open'));
      });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setOpen(!menu.classList.contains('is-open'));
      });
      menu.addEventListener('toggle', function () {
        setOpen(menu.open);
      });
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });
      menu.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !menu.classList.contains('is-open')) return;
        setOpen(false);
        button.focus();
      });
      syncLabel();
    });

    if (document.documentElement.dataset.gdMenuDismissReady !== 'true') {
      document.documentElement.dataset.gdMenuDismissReady = 'true';
      document.addEventListener('click', function (event) {
        document.querySelectorAll('.gd-mobile-menu.is-open, .gd-mobile-menu[open]').forEach(function (menu) {
          if (!menu.contains(event.target)) {
            menu.classList.remove('is-open');
            if ('open' in menu) menu.removeAttribute('open');
            var panel = menu.querySelector('[data-gd-mobile-menu-panel], nav');
            var button = menu.querySelector('[data-gd-mobile-menu-button], .gd-mobile-menu__button, summary');
            if (panel) panel.hidden = true;
            if (button) {
              button.setAttribute('aria-label', 'Ouvrir le menu');
              button.setAttribute('aria-expanded', 'false');
            }
          }
        });
      });
    }
  }

  function initSmoothScroll(root) {
    var scope = root || document;
    scope.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.gdScrollReady === 'true') return;
      link.dataset.gdScrollReady = 'true';
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initFamilyUpgrade(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gd-family-upgrade]').forEach(function (input) {
      if (input.dataset.gdFamilyReady === 'true') return;
      input.dataset.gdFamilyReady = 'true';

      var form = input.closest('form');
      var container = input.closest('.gd-product__actions');
      var message = null;
      if (form) {
        message = form.querySelector('[data-gd-family-message]');
      }
      if (!message && container && container.parentElement) {
        message = container.parentElement.querySelector('[data-gd-family-message]');
      }

      function applyFamilyUpgrade() {
        var quantity = parseInt(input.value, 10);
        if (quantity === 3) {
          input.value = '4';
          quantity = 4;
        }
        if (message) {
          message.hidden = quantity < 4;
        }
      }

      input.addEventListener('input', applyFamilyUpgrade);
      input.addEventListener('change', applyFamilyUpgrade);
      if (form) {
        form.addEventListener('submit', applyFamilyUpgrade);
      }
      applyFamilyUpgrade();
    });
  }

  function initPackSelection(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gd-pack-select]').forEach(function (option) {
      if (option.dataset.gdPackReady === 'true') return;
      option.dataset.gdPackReady = 'true';

      option.addEventListener('click', function () {
        var pack = option.dataset.pack || 'Pack Découverte';
        var quantity = option.dataset.quantity || '1';
        var variantId = option.dataset.variantId || '';

        document.querySelectorAll('[data-gd-family-upgrade]').forEach(function (input) {
          input.value = quantity;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        document.querySelectorAll('[data-gd-cod-pack]').forEach(function (select) {
          select.value = pack;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        document.querySelectorAll('[data-gd-cod-variant]').forEach(function (input) {
          input.value = variantId;
        });
        try {
          window.sessionStorage.setItem('gdSelectedPack', pack);
        } catch (error) {
          // Storage can be unavailable in private or local preview contexts.
        }

        document.querySelectorAll('[data-gd-pack-select]').forEach(function (item) {
          item.classList.toggle('is-selected', item.dataset.pack === pack);
          if (item.dataset.pack === pack) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });
      });
    });
  }

  function initCodForms(root) {
    var scope = root || document;
    scope.querySelectorAll('.gd-cod-form').forEach(function (form) {
      if (form.dataset.gdCodReady === 'true') return;
      form.dataset.gdCodReady = 'true';
      var phone = form.querySelector('input[type="tel"]');
      var submit = form.querySelector('[data-gd-cod-submit]');
      var clientError = form.querySelector('[data-gd-cod-client-error]');
      var packSelect = form.querySelector('[data-gd-cod-pack]');
      var variantInput = form.querySelector('[data-gd-cod-variant]');

      function syncVariantId() {
        if (!packSelect || !variantInput) return;
        var selectedOption = packSelect.options[packSelect.selectedIndex];
        variantInput.value = selectedOption ? selectedOption.dataset.variantId || '' : '';
      }

      function showClientError(message) {
        if (!clientError) return;
        clientError.textContent = message;
        clientError.hidden = !message;
      }

      if (packSelect) {
        try {
          var savedPack = window.sessionStorage.getItem('gdSelectedPack');
          if (savedPack) packSelect.value = savedPack;
        } catch (error) {
          // Keep the default pack when storage is unavailable.
        }
        packSelect.addEventListener('change', function () {
          syncVariantId();
          try {
            window.sessionStorage.setItem('gdSelectedPack', packSelect.value);
          } catch (error) {
            // Selection still works without persistence.
          }
        });
        syncVariantId();
      }

      if (phone) {
        phone.addEventListener('input', function () {
          phone.setCustomValidity('');
          showClientError('');
        });
      }

      form.addEventListener('submit', function (event) {
        form.querySelectorAll('input[type="text"], input[type="tel"]').forEach(function (input) {
          input.value = input.value.trim();
        });

        if (phone) {
          var digits = phone.value.replace(/\D/g, '');
          var validPhone = /^(?:0[5-7]\d{8}|212[5-7]\d{8})$/.test(digits);
          if (!validPhone) {
            event.preventDefault();
            var phoneMessage = 'Entrez un numéro marocain valide, par exemple 0612345678 ou +212612345678.';
            phone.setCustomValidity(phoneMessage);
            showClientError(phoneMessage);
            phone.reportValidity();
            phone.focus();
            return;
          }
        }

        if (navigator.onLine === false) {
          event.preventDefault();
          showClientError('Connexion indisponible. Vérifiez votre réseau puis réessayez.');
          return;
        }

        if (form.hasAttribute('data-gd-cod-preview')) {
          event.preventDefault();
          var fields = form.querySelector('[data-gd-cod-fields]');
          var success = form.querySelector('[data-gd-cod-success]');
          if (fields) fields.hidden = true;
          if (success) {
            success.hidden = false;
            success.focus();
          }
          return;
        }

        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          submit.textContent = submit.dataset.loadingLabel || 'Envoi en cours…';
        }
      });
    });

    scope.querySelectorAll('.gd-cod-success').forEach(function (success) {
      if (!success.hidden) success.focus();
    });
  }

  function initProductGallery(root) {
    var scope = root || document;
    scope.querySelectorAll('.gd-gallery').forEach(function (gallery) {
      if (gallery.dataset.gdGalleryReady === 'true') return;
      gallery.dataset.gdGalleryReady = 'true';

      var mainImage = gallery.querySelector('.gd-gallery__main img');
      var thumbs = gallery.querySelectorAll('.gd-gallery__thumb');
      if (!mainImage || !thumbs.length) return;

      function showThumb(thumb) {
        var image = thumb.querySelector('img');
        if (!image) return;
        mainImage.src = image.dataset.gdFullSrc || image.getAttribute('src');
        if (image.getAttribute('srcset')) {
          mainImage.srcset = image.getAttribute('srcset');
        } else {
          mainImage.removeAttribute('srcset');
        }
        if (image.getAttribute('sizes')) {
          mainImage.sizes = image.getAttribute('sizes');
        } else {
          mainImage.removeAttribute('sizes');
        }
        mainImage.alt = image.alt || mainImage.alt;
        thumbs.forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showThumb(thumb);
        });
        thumb.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          showThumb(thumb);
        });
      });
    });
  }

  function init(root) {
    initAnimatedMedia(root);
    initFaq(root);
    initMobileMenu(root);
    initSmoothScroll(root);
    initFamilyUpgrade(root);
    initPackSelection(root);
    initCodForms(root);
    initProductGallery(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
